export const applePayByPiqPaymentMethodEnabled: boolean = true;
